import { ETheme, EThemeBackground } from '@/common/entity/Enum';
import styled from 'styled-components';

export const ResourceFilterBaseWrapper = styled.div`
  width: 100%;
`;

export const ResourceFilterContentWrapper = styled.div<{$theme?: string}>`
  width: 100%;
  .ResourceFilterGridWrapper {
    background-color: ${(props) => props.$theme === ETheme.Dark ? EThemeBackground.Dark : EThemeBackground.Light};
    border-radius: 8px;
    padding: 8px 8px 0px 8px !important;
  }
  .ResourceFilterBaseWrapper {
    margin-bottom: 8px;
  }
`;

export const ResourceFilterInfoWrapper = styled.div`
  padding-left: 8px;
  padding-right: 8px;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 16px;
  }
`;

export const HeaderTitleWrapper = styled.div<{ $theme?: string }>`
  gap: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: -6px;
`;
